<nav class="bg-white m-0 p-0">
  <div class="flex flex-col">
    <ul class="flex flex-col font-medium m-0 p-0">
      @for (navLink of navLinks; track navLink; let i = $index; let last = $last) {
        @if (isNavLinkVisible(navLink)) {
          <li
            class="relative group mb-2"
            >
            <!-- Parent with children (expandable) -->
            @if (navLink.children) {
              <div class="rounded-lg">
                <button
                  (click)="toggleNavLink(navLink)"
                  class="w-full py-3 px-4 hover:bg-gray-100 hover:text-gray-900 transition text-left font-medium text-gray-700 rounded-lg"
                  >
                  <span class="flex items-center min-w-0 w-full">
                    <ng-icon [name]="navLink.icon" class="inline-block mr-2 shrink-0" style="font-size: 1em;"></ng-icon>
                    <span class="block text-left wrap-break-word flex-1">
                      {{ navLink.label | transloco }}
                    </span>
                    <ng-icon [name]="navLink.isOpen ? 'matKeyboardArrowDown' : 'matKeyboardArrowRight'" class="shrink-0 ml-auto transition-transform duration-200" style="font-size: 1em;"></ng-icon>
                  </span>
                </button>
                <!-- Children -->
                @if (navLink.isOpen) {
                  <ul class="pt-1 space-y-1 border-l-2 border-blue-50 ml-2">
                    @for (child of navLink.children; track child) {
                      <li>
                        @if (isNavLinkVisible(child)) {
                          <a
                            [routerLink]="child.path"
                            [ngClass]="getPathWithoutParams(router.url) === child.path ? 'bg-blue-800 text-white' : 'text-gray-700'"
                            class="block py-2 px-4 hover:bg-gray-100 hover:text-gray-900 transition rounded-lg"
                            (click)="onNavOptionClicked()">
                            <span class="flex items-center min-w-0 w-full">
                              <ng-icon [name]="child.icon" class="inline-block mr-2 shrink-0" style="font-size: 1em;"></ng-icon>
                              <span class="block text-left wrap-break-word w-full">
                                {{ child.label | transloco }}
                              </span>
                            </span>
                          </a>
                        }
                      </li>
                    }
                  </ul>
                }
              </div>
            }
            <!-- Simple nav links (no children) -->
            @if (!navLink.children) {
              <a [routerLink]="navLink.path"
                [ngClass]="getPathWithoutParams(router.url) === navLink.path ? 'bg-blue-800 text-white' : 'text-gray-700'"
                class="block w-full py-3 px-4 hover:bg-gray-100 hover:text-gray-900 transition rounded-lg"
                (click)="onNavOptionClicked()">
                <span class="flex items-center min-w-0 w-full">
                  <ng-icon [name]="navLink.icon" class="inline-block mr-2 shrink-0" style="font-size: 1em;"></ng-icon>
                  <span class="block text-left wrap-break-word w-full">
                    {{ navLink.label | transloco }}
                  </span>
                </span>
              </a>
            }
          </li>
        }
      }
    </ul>
  </div>
</nav>